import { get } from 'lodash';
import { createFetchAction } from '../helpers/fetch';
import { getToken, logout, buildInternalApiUrl } from '../../helpers';

// Actions
export const GET_EMPLOYEES = 'GET_EMPLOYEES';
export const SEARCH_EMPLOYEES = 'SEARCH_EMPLOYEES';
export const CLEAR_EMPLOYEE_DATA = 'CLEAR_EMPLOYEE_DATA';
export const CLEAR_EMPLOYEE_SEARCH_DATA = 'CLEAR_EMPLOYEE_SEARCH_DATA';

// Action Creators
export function getEmployees(nextPage, companyId = get(window, 'asure.appSettings.selectedCompany.companyId'), query = '') {
  const token = getToken();
  const url = companyId ? `${buildInternalApiUrl(token, companyId)}/employees` : `${buildInternalApiUrl(token)}/employees`;
  return createFetchAction(GET_EMPLOYEES, {
    url: query ? `${url}?search=${query}` : nextPage || url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }, 'GETTING_EMPLOYEES', {
    fallbackAction: logout,
    errorCodes: [401],
  });
}

export function searchEmployees(companyId, query) {
  const token = getToken();
  const url = `${buildInternalApiUrl(token, companyId)}/employees`;
  return createFetchAction(SEARCH_EMPLOYEES, {
    url: `${url}?search=${query}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }, 'SEARCHING_EMPLOYEES', {
    fallbackAction: logout,
    errorCodes: [401],
  });
}

export function clearEmployeeData() {
  return {
    type: CLEAR_EMPLOYEE_DATA,
  };
}

export function clearEmployeeSearchData() {
  return {
    type: CLEAR_EMPLOYEE_SEARCH_DATA,
  };
}

const INITIAL_STATE = {
  results: [],
  next: '',
  searchResults: [],
};

export function employees(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_EMPLOYEES: {
      const { payload, payload: { next } = {} } = action;
      const { results } = state;
      const payloadResults = payload && payload.results ? payload.results : [];
      return {
        ...state,
        results: [
          ...results,
          ...payloadResults,
        ],
        next,
      };
    }
    case SEARCH_EMPLOYEES: {
      const { results } = state;
      const { payload: { results: searchResults } = {} } = action;
      return {
        ...state,
        results: [
          ...results,
          ...searchResults,
        ],
        searchResults,
      };
    }
    case CLEAR_EMPLOYEE_DATA: {
      return INITIAL_STATE;
    }
    case CLEAR_EMPLOYEE_SEARCH_DATA: {
      return {
        ...state,
        searchResults: [],
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/employees/employees.js